module.exports = __webpack_public_path__ + "c65202dfbdc29b4a28446f5a7c3f7364.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@deere/cps-it.warranty-base-styles/icons/svg/return.svg
// module id = 116
// module chunks = 0